var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-default',[_c('OTitle',[_vm._v("Terms Of Use")]),_c('CShareThisFollow'),_c('CLegal',[_c('div',{attrs:{"id":"terms"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }